<span [ngStyle]="{'display': authService.isLoggedIn() ? 'none' : '' }">
  <button class="login-box" mat-button (click)="onAuthenticate()">{{ 'header.signIn' | t }}</button>
  <button class="login-box" mat-button (click)="onRegister()">{{ 'header.signUp' | t }}</button>
</span>
<span [ngStyle]="{'display': authService.isLoggedIn() ? 'inline' : 'none' }">
  <button class="login-box" mat-button (click)="onLogout()">
    <i class="material-icons">exit_to_app</i>{{ 'header.signOut' | t }}</button>
</span>
